import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TopNavigation from '../../components/TopNavigation';
import UseCasesHeroSection from './components/UseCasesHeroSection';
import ManufacturingUseCase from './components/ManufacturingUseCase';
import AutomotiveFleetUseCase from './components/AutomotiveFleetUseCase';
import AutomotiveHardwareFarmUseCase from './components/AutomotiveHardwareFarmUseCase';
import MaritimeUseCase from './components/MaritimeUseCase';
import DefenseUseCase from './components/DefenseUseCase';
import TrainingPlatformUseCase from './components/TrainingPlatformUseCase';
import CommonCapabilitiesSection from './components/CommonCapabilitiesSection';
import Footer from '../../components/Footer';

const UseCases = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Use Cases - Sleeve Orchestration Platform</title>
        <meta
          name="description"
          content="Applied orchestration across industries. Each use case demonstrates how Sleeve solves specific system coordination challenges in manufacturing, automotive, maritime, defense, and training environments."
        />
        <meta name="keywords" content="orchestration use cases, manufacturing automation, fleet management, maritime systems, defense coordination, training platform" />
        <meta property="og:title" content="Use Cases - Sleeve Orchestration Platform" />
        <meta property="og:description" content="Applied orchestration across industries for high-stakes, distributed environments" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <TopNavigation />
        
        <main className="content-area">
          <UseCasesHeroSection />
          <ManufacturingUseCase />
          <AutomotiveFleetUseCase />
          <AutomotiveHardwareFarmUseCase />
          <MaritimeUseCase />
          <DefenseUseCase />
          <TrainingPlatformUseCase />
          <CommonCapabilitiesSection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default UseCases;